import React from 'react';
import FollowList from './FollowList.js';

const FollowersPage = () => {
  return (
    <div>
      <FollowList listType="followers" />
    </div>
  );
};

export default FollowersPage;
